import RankingTable from './RankingTable';

export type { RankingTableProps } from './RankingTable';

export default RankingTable;
